import { relations } from 'drizzle-orm'
import {
  AnyPgColumn,
  decimal,
  pgEnum,
  pgTable,
  text,
} from 'drizzle-orm/pg-core'
import {
  getBaseFields,
  getBaseIndexes,
  getNullableIdReference,
} from '../common/utils'
import { employees } from './employee'

export const timesheetModeEnum = pgEnum('timesheet_mode', [
  'visit_based',
  'office_based',
])

export const teams = pgTable(
  'teams',
  {
    ...getBaseFields(),
    name: text().notNull(),
    leaderEmployeeId: getNullableIdReference((): AnyPgColumn => employees.id),
    timesheetMode: timesheetModeEnum().notNull().default('visit_based'),
    defaultStartTime: text(),
    defaultEndTime: text(),
    officeLatitude: decimal({ precision: 10, scale: 8 }),
    officeLongitude: decimal({ precision: 11, scale: 8 }),
    officeAddress: text(),
  },
  (table) => getBaseIndexes('teams', table),
)

export const teamsRelations = relations(teams, ({ one, many }) => ({
  leader: one(employees, {
    fields: [teams.leaderEmployeeId],
    references: [employees.id],
    relationName: 'teamLeader',
  }),
  members: many(employees, { relationName: 'teamMembers' }),
}))
